// src/index.tsx
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { loadGameConfig } from './config/gameConfig';

const screenStyle: React.CSSProperties = {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#0a0a0a',
    color: '#e0e0e0',
    fontFamily: 'system-ui, sans-serif',
    padding: '2rem',
    textAlign: 'center',
};

/**
 * Gates the app on game configuration being available.
 *
 * All game content lives in Firestore, and the accessors in src/data read it
 * synchronously from cache, so nothing may render until that cache is populated.
 */
const Bootstrap: React.FC = () => {
    const [status, setStatus] = useState<'loading' | 'ready' | 'error'>('loading');
    const [error, setError] = useState('');

    useEffect(() => {
        let cancelled = false;
        loadGameConfig()
            .then(() => {
                if (!cancelled) setStatus('ready');
            })
            .catch((err: unknown) => {
                if (cancelled) return;
                console.error('Failed to load game configuration:', err);
                setError(err instanceof Error ? err.message : String(err));
                setStatus('error');
            });
        return () => {
            cancelled = true;
        };
    }, []);

    if (status === 'loading') {
        return <div style={screenStyle}>Mängu andmete laadimine...</div>;
    }

    if (status === 'error') {
        return (
            <div style={{ ...screenStyle, flexDirection: 'column', gap: '1rem' }}>
                <h1 style={{ fontSize: '1.25rem', margin: 0 }}>Mängu andmeid ei õnnestunud laadida</h1>
                <p style={{ maxWidth: '40rem', opacity: 0.8, margin: 0 }}>{error}</p>
            </div>
        );
    }

    return <App />;
};

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <Bootstrap />
    </React.StrictMode>
);
